import { ScheduledSectionStatusServant } from '../servants/scheduled_section_status_servant';
import { TermCourseServant } from '../../term_courses/servants/term_course_servant';
import { MultiSectionServant } from '../servants/multi_section_servant';
import { ISection, IRegistrationSection } from '../../../interfaces/scheduler_interfaces';
import { ScheduledSectionServant } from '../servants/scheduled_section_servant';
import * as _4 from 'lodash4';

export class RegisterSectionFilters {
  constructor(
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngMultiSectionServant: MultiSectionServant,
    private ngTermCourseServant: TermCourseServant,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant
  ) {}

  getScheduledSelectableSections(sections: ISection[]): ISection[] {
    return this.getRegistrableSections(sections).map((section) => {
      const isAllowedToRegister =
        !_4.get(section, 'is_waitlisted', false) && _4.get(section, '_isEligibleForRegistration', false);
      const isSectionSelected = _4.isUndefined(_4.get(section, 'is_selected'))
        ? isAllowedToRegister
        : _4.get(section, 'is_selected', false);
      return {
        ...section,
        is_selected: isSectionSelected
      };
    });
  }

  getRegistrableSections(sections: ISection[]): ISection[] {
    // Multisection course sections with missing section from group.
    const inCompleteMultiSections = _4.filter(
      sections,
      (section: ISection) =>
        this.ngMultiSectionServant.hasUnscheduledRequiredSiblingSections(section, sections) &&
        !this.ngMultiSectionServant.isRegisteredMultiSection(section)
    );
    // Section is Scheduled and has no pin missing && not multi-section or is multisection with pin requirement.
    const isSectionRegistrable = (section: ISection): boolean => {
      const isMultiSection = TermCourseServant.isMultiSectionCourse(section._course);
      const isPending = this.ngScheduledSectionStatusServant.isStatusPending(section);
      const canAddFromWaitlist = this.ngScheduledSectionServant.canAddFromWaitlist(section);
      const isScheduled =
        canAddFromWaitlist ||
        (isMultiSection
          ? this.ngScheduledSectionServant.isSectionScheduledMultiSection(section)
          : ScheduledSectionServant.isSectionScheduled(section));
      const hasDependingWaitlistSections =
        isMultiSection && this.ngMultiSectionServant.hasWaitlistedSiblingSections(section, sections);
      const isStatusRegisteredOrCompleteOrInProgress =
        this.ngScheduledSectionStatusServant.isStatusRegisteredOrCompleteOrInProgress(section);
      return !isStatusRegisteredOrCompleteOrInProgress && !isPending && isScheduled && !hasDependingWaitlistSections;
    };
    return _4.filter(
      sections,
      (section: ISection) => isSectionRegistrable(section) && !_4.includes(inCompleteMultiSections, section)
    );
  }
}

angular.module('capability-ng-scheduler').service('ngRegisterSectionFilters', RegisterSectionFilters);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/filters/register_sections_filters.ts